import "./assets/scss/style.scss";
import "./assets/scss/font.scss";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

// CONTAINERS
import Home from "./containers/Home";
import FormEdit from "./containers/FormEdit";
import FormAdd from "./containers/FormAdd";
import FormAnswer from "./containers/FormAnswer";
// COMPONENTS
import Header from "./components/Header";

function App() {
  return (
    <Router>
      <Header />
      <Switch>
        <Route path="/form/add">
          <FormAdd />
        </Route>
        <Route path="/form/:id/edit">
          <FormEdit />
        </Route>
        <Route path="/form/:id">
          <FormAnswer />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
